import { render, staticRenderFns } from "./ExamineTask.vue?vue&type=template&id=799ac2cf&scoped=true&"
import script from "./ExamineTask.vue?vue&type=script&lang=js&"
export * from "./ExamineTask.vue?vue&type=script&lang=js&"
import style0 from "./ExamineTask.vue?vue&type=style&index=0&id=799ac2cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799ac2cf",
  null
  
)

export default component.exports